/**
 * @file: im人机聊天的socket
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2024-01-17 16:24:03
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-01-22 17:55:18
 * @FilePath: /console-znzs/new_src/utils/ImSocket.js
 */
import Sockette from '@/znzs/new_src/utils/socket';

const defaultOptions = {
    // 心跳包频率
    heartbeatInterval: 5000,
    // 连接超时时长
    timeout: 2000,
    // 最大重试次数
    maxAttempts: 999,
    // 消息中的cmd对应的名称，用来作为区分cmd的key
    commandKey: 'channel',
    // 链接成功
    onConnect: () => {},
    // 链接断开
    onDisConnect: () => {},
};

class IMSocket {
    constructor(sessionId, options) {
        if (options) {
            this.options = Object.assign({}, defaultOptions, options);
        }
        else {
            this.options = defaultOptions;
        }
        this.url = `wss://${location.host}/api/znzs/ws/customer/?sessionId=${sessionId}`;
        this.socket = this.createInstance();
    }
    createInstance() {
        if (!this.url) {
            return null;
        }
        return new Sockette(this.url, {
            timeout: this.options.timeout,
            maxAttempts: this.options.maxAttempts,
            onopen: this.onOpen.bind(this),
            onmessage: this.onMessage.bind(this),
            onreconnect: this.onreconnect.bind(this),
            onmaximum: this.onmaximum.bind(this),
            onclose: this.onClose.bind(this),
            onerror: this.onError.bind(this),
        });
    }
    close() {
        if (this.socket) {
            this.socket.close();
        }
    }

    ack(ackId, uniqueId) {
        this.send({
            cmd: ackId,
            data: {
                uniqueId,
            },
        });
    }

    send(data) {
        if (this.socket) {
            this.socket.json(data);
        }
    }

    // 发送心跳包
    onOpen() {
        this.heartBeat();
        if (this.options.onConnect) {
            this.options.onConnect();
        }
    }
    heartBeat() {
        this.send({
            cmd: 3,
        });
        this.hearbeat = setTimeout(() => {
            this.heartBeat();
        }, this.options.heartbeatInterval);
    }

    onMessage(event) {
        const {cmd, ...data} = JSON.parse(event.data);
        if (cmd === 0 && data.msg === 'to many connections') {
            this.close();
            return;
        }
        if (cmd === 4) {
            return;
        }
        const messageKey = this.options.commandKey + ':' + cmd;
        if (this.options[messageKey]) {
            this.options[messageKey](data);
        }
    }
    // 正在重连
    onreconnect() {}
    // 达到最大重试次数
    onmaximum() {}
    // 连接关闭
    onClose() {
        if (this.hearbeat) {
            clearTimeout(this.hearbeat);
        }
        if (this.options.onDisConnect) {
            this.options.onDisConnect();
        }
    }
    // 连接错误，例如服务不在线
    onError() {}
}

export default IMSocket;